import { combineReducers } from "@reduxjs/toolkit";
import GameSlice from "../services/GameSlice";
import NotificationSlice from "../services/NotificationSlice";
import AccountSlice from "../services/AccountSlice";

const appReducer = combineReducers({
    game: GameSlice,
    notificationHandler: NotificationSlice,
    account: AccountSlice
})

const rootReducer = (state, actions) => {
    return appReducer(state, actions)
}

export default rootReducer;